import BaseClient from "./BaseClient";
import {isAfter} from "date-fns";

export default class TransactionServiceClient extends BaseClient {
    constructor(billingDate = null, tenantId: string) {
        super(billingDate, tenantId, true, "ams");
    }
    public async getAccount(accountId: string) {
        const response = await this.get(`/api/proxy/ams/transaction-service/account/${accountId}`);
        return await this.handleResponse<TransactionAccountAvailableCredit>(response);
    }

    public async getPendingAuthorizations(accountId: string) {
        const response = await this.get(`/api/proxy/ams/transaction-service/account/${accountId}/auth`);
        return await this.handleResponse<PendingAuthorizations>(response);
    }

    public async payment(accountId: string, amount: number, description: string, effectiveDate: Date, creditRelease: string = null) {
        let body = {
            amount: {
                value: amount,
                currencyCode: 'GBP'
            },
            transactionDate: this._billingDate.toISOString(),
            effectiveDate: isAfter(this._billingDate, effectiveDate) ? effectiveDate : undefined,
            balanceMovementType: 'Payment',
            spendType: 'Purchase',
            creditRelease: creditRelease,
            description
        }
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${accountId}/transaction`, body);
        return await this.handleResponse(response);
    }

    public async refund(accountId: string, originalTransactionId: string, amount: Amount, description: string, upfrontPaymentRefundAmount?: Amount) {
        const body = {
            originalTransactionId,
            amount,
            description,
            upfrontPaymentRefundAmount
        };
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${accountId}/refund`, body);
        return await this.handleResponse(response);
    }

    public async refundUpfrontPayment(accountId: string, originalTransactionId: string, refundAmount: Amount) {
        const body = {
            refundAmount
        };
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${accountId}/transaction/${originalTransactionId}/refund-upfront-payment`, body);
        return await this.handleResponse(response);
    }

    public async reverseTransaction(accountId: string, transactionId: string, description: string) {
        let body = {
            description
        }
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${accountId}/transaction/${transactionId}/reverse`, body);
        return await this.handleResponse(response);
    }

    public async releasePayment(accountId: string, transactionId: string) {
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${accountId}/transaction/${transactionId}/release`, null);
        return await this.handleResponse(response);
    }

    public async changeStatus(accountId: string, transactionId: string, newTransactionStatus) {
        let body = {
            transactionStatus: newTransactionStatus
        }
        const response = await this.put(`/api/proxy/ams/transaction-service/account/${accountId}/transaction/${transactionId}/status`, body);
        return await this.handleResponse(response);
    }


    public async adjustment(accountId: string, direction: string, amount: number, description: string, reason: string, effectiveDate: Date, originalTransactionId: null | string) {
        let body = {
            originalTransactionId: originalTransactionId,
            direction,
            effectiveDate: isAfter(this._billingDate, effectiveDate) ? effectiveDate : null,
            description,
            reason,
            amount : {
                value : amount,
                currencyCode : "GBP"
            }
        }
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${accountId}/adjustment`, body);
        return await this.handleResponse(response);
    }

    public async authorise(accountId: string, amount: number, authorisationDate: string, description: string, spendType: string) {
        const body = {
            amount: {
                value: amount,
                currencyCode: 'GBP',
            },
            authorizationDate: authorisationDate,
            description: description,
            spendType: spendType
        }
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${accountId}/auth`, body);
        return await this.handleResponse<CreateAuthorisationResponse>(response);
    }

     public async createTransaction(req: {accountId: string, amount: number, balanceMovementType: string, description: string, 
        authorisationId?: string, effectiveDate: string, creditRelease: string, externalId: string, reason: string,
        spendType?: string, offerDetails: OfferDetails, upfrontPaymentAmount?: number
     }
     ) {
        const body = {
            amount: {
                value: req.amount,
                currencyCode: 'GBP',
            },
            upfrontPaymentAmount: req.upfrontPaymentAmount == null ? undefined : {
                value: req.upfrontPaymentAmount,
                currencyCode: 'GBP',
            },
            balanceMovementType: req.balanceMovementType,
            description: req.description,
            authorizationId: req.authorisationId,
            effectiveDate: req.effectiveDate,
            creditRelease: req.creditRelease,
            externalId: req.externalId,
            reason: req.reason,
            offerDetails: req.offerDetails,
            spendType: req.spendType,
        }
        const response = await this.post(`/api/proxy/ams/transaction-service/account/${req.accountId}/transaction`, body);
        return await this.handleResponse(response);
    }
}

export const useTransactionService = (billingDate = null, tenantId: string): TransactionServiceClient => {
    return new TransactionServiceClient(billingDate, tenantId);
};